export default __webpack_public_path__ + "media/spot-hero-illustrations.1db62ef8bc48ee2a53974c42ebc66b10.svg";